import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { NotificationService } from '../../shared/services/notification.service';

@Injectable({
  providedIn: 'root',
})
export class GraphqlErrorInterceptor implements HttpInterceptor {
  private oidc = inject(OidcSecurityService);
  private notificationService = inject(NotificationService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event: any) => {
        if (event?.body?.errors?.length) {
          this.handleGraphqlErrors(event.body.errors);
        }

        const responseData = event?.body?.data;
        if (responseData) {
          const firstKey = Object.keys(responseData)[0];
          const payload = responseData[firstKey];

          if (payload?.status === false) {
            this.handleBusinessError(payload);
          }
        }
      }),

      catchError((error: HttpErrorResponse) => {
        this.handleHttpError(error);
        return throwError(() => error);
      })
    );
  }

  private handleGraphqlErrors(errors: any[]): void {
    let hasAccessDenied = false;
    errors.forEach((err) => {
      console.error('[GraphQL Error]', err.message);
      if (err.message && err.message.toLowerCase().includes('access denied')) {
        hasAccessDenied = true;
      }
    });

    if (hasAccessDenied) {
      this.notificationService.errorMessage(
        'Access Denied: You do not have the required access/permissions to view this resource.'
      );
    }
  }

  private handleBusinessError(payload: any): void {
    console.warn('[Business Error]', payload.message);
  }

  private handleHttpError(error: HttpErrorResponse): void {
    switch (error.status) {
      case 0:
        console.error('Server unreachable');
        break;
      case 401:
        console.error('Unauthorized');
        //this.oidc.logoff().subscribe();
        break;
      case 403:
        console.error('Forbidden');
        break;
      case 500:
        console.error('Server error');
        break;
      case 503:
        console.error('Service is unavailable');
        break;
      default:
        console.error('HTTP Error:', error);
    }
  }
}
